module.exports = __webpack_public_path__ + "static/media/01 home.9c9c74a1.jpg";